module.exports = __webpack_public_path__ + "static/media/7.93dbb54f.jpg";